import * as React from "react";
import DataComponent from "../common/DataComponent";
import MiniSpinner from "../common/MiniSpinner";
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import { Modal } from "../ecosystem";
import FavoriteButton from './FavoriteButton';


class FavoriteDrButton extends DataComponent {

    constructor(props) {
        super(props);
        this.state = {
            processing: false,
            showModal: false,
            modalText: null,
            yesFunction: null,
            noFunction: null,
            yesParameter: null
        };
        this.removeProvider = this.removeProvider.bind(this);
        this.addProvider = this.addProvider.bind(this);
        this.stopProcessing = this.stopProcessing.bind(this);
        this.removeProviderClick = this.removeProviderClick.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
    }

    componentDidMount() {
        if (super.componentDidMount) { super.componentDidMount(); }
        //logUI("MBHWeb.UI.FavoritedLabel.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    addProvider(npi, event) {
        event.preventDefault();
        event.stopPropagation();
        const { NPI, addProviderToFavorites } = this.props;
        const { processing } = this.state;
        if (!processing) {
            //debugger;
            this.setState({ processing: true });
        }
        addProviderToFavorites(npi, this.stopProcessing);
        logUI("MBHWeb.Settings.Favorite.Add", new Date(), Tools.getURLPath());
        return false;
    }

    removeProviderClick(npi, event) {
        event.preventDefault();
        event.stopPropagation();
        const { showModal } = this.state;
        if (!showModal) {
            this.setState({
                showModal: true,
                modalText: "Are you sure you want to remove this doctor from your favorites?",
                yesFunction: this.removeProvider,
                noFunction: this.closeDialog,
                yesParameter: npi
            });
        }
        return false;
    }

    closeDialog() {
        const { showModal } = this.state;
        if (showModal && this._isMounted) {
            this.setState({ showModal: false });
        }
    }

    removeProvider(npi) {
        const { removeFavoriteProvider } = this.props;
        const { processing } = this.state;
        this.closeDialog();
        if (!processing) {
            //debugger;
            this.setState({ processing: true });
        }
        removeFavoriteProvider(npi, this.stopProcessing);
        logUI("MBHWeb.Settings.Favorite.Remove", new Date(), Tools.getURLPath());
    }

    stopProcessing() {
        const { processing } = this.state;
        if (processing && this._isMounted) {
            this.setState({ processing: false });
        }
        this.props.loadFavoriteProviders();
        this.props.loadRecentVisitedDoctors();
    }

    render() {
        const { processing, showModal, modalText, yesFunction, noFunction, yesParameter } = this.state;
        const { NPI, IsFavorited, fetching, isProxyUser, showLabel, isMobile } = this.props;
        if (isProxyUser) { return "" };

        return (
            <React.Fragment>
                <Modal
                    isOpen={showModal}
                    alignText={isMobile ? "center" : "left"}
                    alignFooter={"right"}
                    modalHeader={"Remove this doctor?"}
                    modalBody={modalText}
                    modalFooterButtons={[
                        { label: "Yes, remove doctor", onClick: () => yesFunction(yesParameter) },
                        { label: "Cancel", onClick: () => noFunction() },
                    ]}
                />
                <>
                    {processing 
                        ? <MiniSpinner />
                        : <FavoriteButton
                            isFavorited={IsFavorited}
                            showLabel={showLabel}
                            addOnClick={(e) => this.addProvider(NPI, e)}
                            removeOnClick={(e) => this.removeProviderClick(NPI, e)}
                            tooltipId={`favorite-tooltip-${NPI}`}
                        />
                    }
                </>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const { NPI } = ownProps;
    return {
        isLoggedIn: state.domain.li,
        FavoriteProviders: state.healthSource.arrayFavoriteNPIs,
        fetching: state.healthSource.fetchingFavoriteProviders,
        IsFavorited: state.healthSource.arrayFavoriteNPIs && state.healthSource.arrayFavoriteNPIs.length > 0 ? state.healthSource.arrayFavoriteNPIs.find((npi) => { return npi === NPI; }) : false,
        isProxyUser: state.domain.ip
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addProviderToFavorites: (npi, completionCallback) => {
            dispatch({
                type: types.ADD_FAVORITE_PROVIDER_START,
                npi: npi,
                completionCallback: completionCallback
            });
        },
        removeFavoriteProvider: (npi, completionCallback) => {
            dispatch({
                type: types.REMOVE_FAVORITE_PROVIDER_START,
                npi: npi,
                completionCallback: completionCallback
            });
        },
        loadFavoriteProviders: () => {
            dispatch({
                type: types.GET_FAVORITE_PROVIDERS_START
            });
        },
        loadRecentVisitedDoctors: () => {
            dispatch({
                type: types.GET_RECENT_VISITED_DOCTORS_START
            });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FavoriteDrButton);

